export const sortByOrderAscending = (components) => {
    return [...components].sort((a, b) => a.Order - b.Order);
}